if (!customElements.get('mega-menu-products')) {
  customElements.define(
    'mega-menu-products',
    class MegaMenuProducts extends HTMLElement {
      constructor() {
        super();

        this.scroller = this.querySelector('[data-mega-scroller]');
        this.prevButton = this.querySelector('[data-mega-scroll="prev"]');
        this.nextButton = this.querySelector('[data-mega-scroll="next"]');

        this.prevButton?.addEventListener('click', () => this.scrollByPage(-1));
        this.nextButton?.addEventListener('click', () => this.scrollByPage(1));
        this.scroller?.addEventListener('scroll', this.updateButtons.bind(this));
        window.addEventListener('resize', this.updateButtons.bind(this));

        this.resizeObserver = new ResizeObserver(() => this.updateButtons());
        if (this.scroller) this.resizeObserver.observe(this.scroller);
        this.updateButtons();
      }

      disconnectedCallback() {
        this.resizeObserver?.disconnect();
      }

      scrollByPage(direction) {
        if (!this.scroller) return;
        this.scroller.scrollBy({ left: this.scroller.clientWidth * direction, behavior: 'smooth' });
      }

      updateButtons() {
        if (!this.scroller || !this.prevButton || !this.nextButton) return;
        const { scrollLeft, scrollWidth, clientWidth } = this.scroller;
        const canScroll = scrollWidth > clientWidth + 1;

        this.prevButton.disabled = false;
        this.prevButton.setAttribute('aria-disabled', String(!canScroll || scrollLeft <= 1));
        this.nextButton.disabled = false;
        this.nextButton.setAttribute('aria-disabled', String(!canScroll || scrollLeft + clientWidth >= scrollWidth - 1));
      }
    }
  );
}
